<template>
  <div>
    <ListWrapper
      ref="listWrapper"
      :url="generateUrl"
      :extraButtons="extraButtons"
      :hasAddButton="false"
      :insideHeaderClass="
        !isAllParvandehPage && checkScreenDevice(['tablet', 'mobile'])
          ? 'header'
          : ''
      "
      :hasTitle="hasTitle"
      :isUseInSidebar="isUseInSidebar"
      :emptyImage="generateEmptyImage"
      :emptyText="generateEmptyText"
      :hasBackButton="!isAllParvandehPage"
      backButtonIcon="arrow-right"
      @handleBackButton="goToCenterExecuteList"
      @getPermissions="getPermissions"
      @getOtherData="getOtherData"
    >
      <template
        v-if="!isAllParvandehPage && checkScreenDevice(['tablet', 'mobile'])"
        #back-button-area
      >
        <span
          class="margin-left-8 color-complementary-300 cursor-pointer"
          @click="goToCenterExecuteList"
        >
          <mdicon size="24" name="arrow-right" />
        </span>
      </template>
      <template slot-scope="{ items }">
        <CardList
          :items="generateItems(items)"
          loadingComponent="CenterExecuteCases"
          :showBody="showBody"
        >
          <template slot="header" slot-scope="{ item }">
            <b-row class="margin-0 width-percent-100">
              <b-col
                cols="12"
                lg="5"
                class="flex-start flex-direction-column padding-0"
              >
                <HeaderRowRightItems
                  mode="MOBILE"
                  :item="item"
                  :menuPopupItems="generateItemButtons(item)"
                  :permissions="permissions"
                  :goToCompetencyLink="generateCompetencyPageRouteLink(item)"
                />
                <div
                  class="font-size-14 margin-bottom-8 width-percent-100 flex-between"
                >
                  <span class="padding-left-4 color-complementary-400">
                    {{ item.exerciseName }}
                  </span>
                </div>
                <div
                  class="font-size-12 color-complementary-300 width-percent-100 desktop-flex-start"
                >
                  <div>
                    <span v-if="item.startTime">
                      {{ $lang.start }}: {{ item.startTime }}
                    </span>
                    <span v-if="item.sendTime">
                      <span class="color-complementary-100"> | </span>
                      {{ $lang.send }}: {{ item.sendTime }}
                    </span>
                  </div>
                  <div
                    v-if="item.delaySend && !item.isAbsent"
                    class="flex-start mobile-margin-bottom-8"
                  >
                    <span
                      class="color-complementary-100 mobile-none tablet-none margin-x-4"
                    >
                      |
                    </span>
                    <span
                      class="background-error-300 color-surface padding-x-8 padding-y-2 border-radius-8 width--max-content flex-start"
                    >
                      <span class="margin-left-8">
                        <mdicon name="alert-circle" size="16" />
                      </span>
                      {{ $lang.sendDelay }}: {{ item.delaySend }}
                      {{ $lang.minute }}
                    </span>
                  </div>
                </div>
                <div
                  v-if="isAllParvandehPage"
                  class="font-size-12 color-complementary-300 margin-bottom-8 width-percent-100 flex-between"
                >
                  {{ $lang.centerExecuteName }}:
                  {{ pathOr("", ["center_execute", "name"], item) }}
                </div>
              </b-col>
              <b-col
                cols="12"
                lg="4"
                class="font-size-12 color-complementary-300 padding-0"
              >
                <AvatarGroup
                  :data="generateCandidateData(item)"
                  :hasProfilePopup="false"
                />
                <AvatarGroup
                  :data="generateAssessorsData(item)"
                  :hasProfilePopup="false"
                />
              </b-col>
              <b-col cols="12" lg="3" class="padding-0">
                <HeaderRowRightItems
                  mode="DESKTOP"
                  :item="item"
                  :menuPopupItems="generateItemButtons(item)"
                  :permissions="permissions"
                  :goToCompetencyLink="generateCompetencyPageRouteLink(item)"
                />
                <div
                  v-if="item.notConfirmedCompetency > 0 && !item.isAbsent"
                  class="desktop-flex-end flex margin-top-16 margin-left-14 font-size-12"
                >
                  <span class="margin-left-8 color-error">
                    {{ $lang.notConfirmedCompetency }}:
                  </span>
                  <span
                    :class="`chips chips--error chips--pill direction--ltr`"
                  >
                    {{ item.notConfirmedCompetency }}
                  </span>
                </div>
              </b-col>
            </b-row>
          </template>
          <template slot="card-body" slot-scope="{ item }">
            <b-row class="m-0">
              <b-col
                v-if="!isAllParvandehPage"
                cols="12"
                class="padding-0 margin-bottom-8"
              >
                {{ $lang.centerExecuteName }}:
                {{ pathOr("", ["centerExecuteName"], item) }}
              </b-col>
              <b-col cols="12" class="padding-0 margin-bottom-8">
                {{ $lang.term }}: {{ pathOr("", ["termCaption"], item) }}
              </b-col>
              <b-col cols="12" class="padding-0 margin-bottom-8">
                {{ $lang.acParvandehNumber }}:
                {{ pathOr("", ["id"], item) }}
              </b-col>
              <b-col cols="12" class="padding-0 margin-bottom-8">
                {{ $lang.room }}: {{ pathOr("", ["room"], item) }}
              </b-col>
            </b-row>
          </template>
        </CardList>
      </template>
    </ListWrapper>
    <Modal
      :show="candidateAbsentModal.show"
      :title="$lang.setAbsent"
      :closeOnBackdrop="false"
      :hasClose="false"
      :okButton="true"
      :okButtonText="$lang.setAbsent"
      okButtonVariant="filled-error"
      size="sm"
      :okLoading="candidateAbsentModal.loading"
      :ok="setCandidateAbsent"
      @close="handleCloseCandidateAbsentModal"
    >
      <template #body>
        <div>
          <div class="margin-bottom-24 font-size-14 color-complementary-300">
            {{ $lang.setAbsentDescription }}
          </div>
          <Input
            :title="`${$lang.absentReason} (${$lang.optional})`"
            :label="$lang.absentReason"
            :placeholder="$lang.absentReason"
            :value="form.absentReason"
            name="absentReason"
            id="absentReason"
            type="textarea"
            :minLength="lengthNumber3"
            :maxLength="lengthNumber256"
            :vuelidateObj="$v.form.absentReason"
            @input="input"
            @focus="resetValidation"
            @blur="checkValidation"
          />
        </div>
      </template>
    </Modal>
    <Modal
      :show="exerciseAbsentModal.show"
      :title="$lang.notPresentInExercise"
      :closeOnBackdrop="false"
      :hasClose="false"
      :okButton="true"
      :okButtonText="$lang.notPresentInExercise"
      okButtonVariant="filled-error"
      size="sm"
      :okLoading="exerciseAbsentModal.loading"
      :ok="setExerciseAbsent"
      @close="handleCloseExerciseAbsentModal"
    >
      <template #body>
        <div>
          <div class="margin-bottom-24 font-size-14 color-complementary-300">
            {{ $lang.setAbsentInExerciseDescription }}
          </div>
        </div>
      </template>
    </Modal>
    <Modal
      :show="isChangeAssessorModal"
      :title="$lang.changeAssessor"
      :closeOnBackdrop="false"
      :hasClose="false"
      :hasFooter="false"
      size="sm"
      @close="handleCloseChangeAssessorModal"
    >
      <template #body>
        <ChangeAssessor
          :item="currentItem"
          @handleClose="handleCloseChangeAssessorModal"
        />
      </template>
    </Modal>
  </div>
</template>

<script>
/*
  Description for is_absent flag:
  When non-attendance at the training is marked,
  it means the absence of this file, but when the participant's absence is registered,
  all the files of that participant are removed from the list of files.
*/

import inputMixin from "@/mixin/inputMixin.vue";
import {
  ListWrapper,
  CardList,
  AvatarGroup,
  Modal,
} from "@/components/re-design";
import { Input } from "@/components/re-design/forms";
import ChangeAssessor from "./components/ChangeAssessor.vue";
import HeaderRowRightItems from "./components/HeaderRowRightItems.vue";
import { required } from "vuelidate/lib/validators";
import { pathOr, includes, has } from "ramda";
import {
  generateApiUrl,
  generateError,
  generateRouteLink,
  goToRoute,
  sleep,
  toastAlert,
  checkScreenDevice,
} from "@/shared/utils";
import { mapActions, mapGetters } from "vuex";
import {
  setCenterExecuteAbsent,
  setParvandehSetAbsent,
} from "@/modules/kanoon/services";

export default {
  mixins: [inputMixin],
  components: {
    ListWrapper,
    CardList,
    AvatarGroup,
    Modal,
    Input,
    ChangeAssessor,
    HeaderRowRightItems,
  },
  provide() {
    // provide this data to all deep child components
    return {
      listWrapperReload: this.listWrapperReload,
    };
  },
  props: {
    hasTitle: {
      type: Boolean,
      default: true,
    },
    isUseInSidebar: {
      type: Boolean,
      default: false,
    },
  },
  validations() {
    return {
      form: {
        absentReason: {},
      },
    };
  },
  data() {
    return {
      permissions: [],
      otherData: null,
      form: {
        absentReason: null,
      },
      buttons: [
        {
          caption: this.$lang.gradingCompetency,
          show: true,
          permissions: ["admin", "edit"],
          loading: false,
          link: this.generateCompetencyPageRouteLink,
        },
        {
          caption: this.$lang.changeAssessor,
          show: true,
          permissions: ["admin", "edit", "view"],
          allowStatus: [1],
          allowUserExecutiveRoles: [3],
          isAbsent: false,
          loading: false,
          click: this.handleOpenChangeAssessorModal,
        },
        {
          caption: this.$lang.notPresentInExercise,
          show: true,
          permissions: ["admin", "edit"],
          allowStatus: [1],
          allowUserExecutiveRoles: [3],
          isAbsent: false,
          loading: false,
          click: this.handleOpenExerciseAbsentModal,
        },
        {
          caption: this.$lang.notPresentCandidate,
          show: true,
          permissions: ["admin", "edit"],
          allowStatus: [1],
          allowUserExecutiveRoles: [3],
          loading: false,
          click: this.handleOpenCandidateAbsentModal,
        },
      ],
      candidateAbsentModal: {
        loading: false,
        show: false,
        item: null,
      },
      exerciseAbsentModal: {
        loading: false,
        show: false,
        item: null,
      },
      isChangeAssessorModal: false,
      currentItem: null,
    };
  },
  computed: {
    ...mapGetters("kanoon", ["centerExecuteListBackRoute"]),
    generateUrl() {
      const isAllParvandehPage = this.$route.name === "all_center_execute_case";
      const centerExecuteId = pathOr(
        null,
        ["centerExecuteId"],
        this.$route.params
      );
      return isAllParvandehPage
        ? generateApiUrl(["kanoon", "all_center_execute_case"])
        : generateApiUrl(
            ["kanoon", "v2", "centerExecuteCases"],
            [centerExecuteId]
          );
    },
    extraButtons() {
      return [];
    },
    generateEmptyImage() {
      return this.$config.images.shared.redesign.empty.list;
    },
    generateEmptyText() {
      return this.$lang.list_empty_text;
    },
    isAllParvandehPage() {
      return this.$route.name === "all_center_execute_case";
    },
  },
  methods: {
    ...mapActions(["setAction"]),
    pathOr,

    checkScreenDevice,
    listWrapperReload() {
      this.$refs.listWrapper.reload();
    },
    generateItems(items) {
      return items.map((item) => {
        return {
          ...item,
          statusId: pathOr(null, ["status", "id"], item),
          statusCaption: pathOr("", ["status", "caption"], item),
          isAbsent: pathOr(false, ["is_absent"], item),
          exerciseName: pathOr("", ["exercise", "name"], item),
          startTime: pathOr("", ["start_time"], item),
          sendTime: pathOr("", ["send_time"], item),
          delaySend: pathOr(0, ["delay_send_minutes"], item),
          notConfirmedCompetency: pathOr(0, ["not_confirmed_competency"], item),
          evidenceErrorCount: pathOr(0, ["evidence_error_count"], item),
          disabled: pathOr(false, ["is_absent"], item), // set disabled item when is_absent flag is true
        };
      });
    },
    getPermissions(value) {
      this.permissions = value;
    },
    getOtherData(value) {
      this.otherData = value;
    },
    generateItemButtons(item) {
      const userExecutiveRoles = this.isAllParvandehPage
        ? item
        : this.otherData;
      const userExecuteRole = pathOr(
        null,
        ["executive_role", "id"],
        userExecutiveRoles
      );
      const statusId = pathOr(null, ["status", "id"], item);
      return this.buttons.filter((button) => {
        // check allow status
        const allowStatus = pathOr([], ["allowStatus"], button);
        let condition = true;
        if (allowStatus.length) {
          condition = condition && includes(statusId, allowStatus);
        }

        // check allow user executive role
        const allowUserExecutiveRoles = pathOr(
          [],
          ["allowUserExecutiveRoles"],
          button
        );
        if (allowUserExecutiveRoles.length) {
          condition =
            condition && includes(userExecuteRole, allowUserExecutiveRoles);
        }

        // check is absend
        if (has("isAbsent", button)) {
          condition = condition && !button.isAbsent;
        }

        return condition;
      });
    },
    generateCandidateData(item) {
      const candidateName = pathOr(
        "",
        ["candidate", "person", "full_name"],
        item
      );
      const candidateNumber = pathOr(
        "",
        ["candidate", "person_center_execute_code"],
        item
      );
      const type = pathOr(
        "شرکت کننده",
        ["candidate", "person", "national_code"],
        item
      );
      return {
        type,
        id: candidateNumber,
        name: candidateName,
        images: [pathOr("", ["candidate", "person", "img"], item)],
      };
    },
    generateAssessorsData(item) {
      const assessor = pathOr(null, ["assessor"], item);
      const secondAssessor = pathOr(null, ["second_assessor"], item);
      const assessorName = pathOr("", ["person", "full_name"], assessor);
      const secondAssessorName = pathOr(
        "",
        ["person", "full_name"],
        secondAssessor
      );
      const assessorNumber = pathOr(
        "",
        ["person_center_execute_code"],
        assessor
      );
      const assessorImage = pathOr("", ["person", "img"], assessor);
      const secondAssessorImage = pathOr("", ["person", "img"], secondAssessor);
      return {
        type: "ارزیاب",
        id: assessorNumber,
        name: secondAssessor
          ? `${assessorName} ${this.$lang.and} ${secondAssessorName}`
          : assessorName,
        images: secondAssessor
          ? [assessorImage, secondAssessorImage]
          : [assessorImage],
      };
    },
    handleOpenCandidateAbsentModal(item) {
      this.candidateAbsentModal.item = item;
      this.candidateAbsentModal.show = true;
    },
    handleCloseCandidateAbsentModal() {
      this.candidateAbsentModal.show = false;
      this.form.absentReason = null;
    },
    async setCandidateAbsent() {
      this.$v.form.absentReason.$touch();
      if (this.$v.form.absentReason.$anyError) return;

      try {
        this.candidateAbsentModal.loading = true;
        const item = this.candidateAbsentModal.item;
        const centerExecuteId = pathOr(null, ["center_execute", "id"], item);
        const candidateId = pathOr(
          null,
          ["candidate", "center_execute_candidate_id"],
          item
        );
        const { absentReason } = this.form;

        const response = await setCenterExecuteAbsent(
          centerExecuteId,
          candidateId,
          absentReason
        );
        const { message } = response;
        toastAlert(message);
        this.handleCloseCandidateAbsentModal();
        this.listWrapperReload();
      } catch (error) {
        generateError(error);
      } finally {
        this.candidateAbsentModal.loading = false;
      }
    },
    handleOpenExerciseAbsentModal(item) {
      this.exerciseAbsentModal.item = item;
      this.exerciseAbsentModal.show = true;
    },
    handleCloseExerciseAbsentModal() {
      this.exerciseAbsentModal.show = false;
    },
    async setExerciseAbsent() {
      try {
        this.exerciseAbsentModal.loading = true;
        const item = this.exerciseAbsentModal.item;
        const centerExecuteId = pathOr(null, ["center_execute", "id"], item);
        const id = pathOr(null, ["id"], item);

        const response = await setParvandehSetAbsent(centerExecuteId, id);
        const { message } = response;
        toastAlert(message);
        this.handleCloseExerciseAbsentModal();
        this.listWrapperReload();
      } catch (error) {
        generateError(error);
      } finally {
        this.exerciseAbsentModal.loading = false;
      }
    },
    async showBody(item) {
      // TODO: get data with service (service dos'nt created)
      try {
        await sleep(500);
        return {
          id: pathOr(null, ["id"], item),
          centerExecuteName: pathOr("", ["center_execute", "name"], item),
          termCaption: pathOr("", ["term", "caption"], item),
          room: pathOr("", ["room_name"], item),
        };
      } catch (error) {
        generateError(error);
      }
      /*  try {
         const id = pathOr(null, ["id"], item);
        const response = await getCenterExecuteCase(id);
        return response;
      } catch (error) {
        generateError(error);
      } */
    },
    handleOpenChangeAssessorModal(item) {
      this.currentItem = item;
      this.isChangeAssessorModal = true;
    },
    handleCloseChangeAssessorModal() {
      this.isChangeAssessorModal = false;
    },
    generateCompetencyPageRouteLink(item) {
      const name = "center-execute-case-competency";
      const params = {
        centerExecuteId: pathOr(null, ["center_execute", "id"], item),
        caseId: pathOr(null, ["id"], item),
      };
      let link = generateRouteLink(name, params);
      link = link.replace("/v2", "");
      return link;
    },
    goToCenterExecuteList() {
      const centerExecuteListBackRoute = localStorage.getItem(
        "centerExecuteListBackRoute"
      );
      goToRoute(centerExecuteListBackRoute, {}, {}, false);
    },
  },
};
</script>
